import * as yup from 'yup';

export interface IVerifyPhone {
	code: string;
}

export const verifyPhoneInitialValues: IVerifyPhone = {
	code: '',
};

export const verifyPhoneSchema = yup.object().shape({
	code: yup.string().required('generalForm:required'),
});
